import { render, staticRenderFns } from "./ProducerCommissionsManager.vue?vue&type=template&id=182ab2c6&scoped=true"
import script from "./ProducerCommissionsManager.vue?vue&type=script&lang=js"
export * from "./ProducerCommissionsManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182ab2c6",
  null
  
)

export default component.exports